import {searchLogger, searchErrorLogger} from '../src/core/Logger'
import {createApp, ref} from 'vue';
import AutocompletePopup from './components/AutocompletePopup/AutocompletePopup.vue';
import SerpPage from './components/SerpPage/SerpPage.vue';

import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from './core/types'
import {restoreDefaultSettings, fetchFrontSettings, searchIsConfigured, deepAssign} from './core/utils'
import {createPinia} from 'pinia'
import DefaultConfig from '../public/config/DefaultConfig.json';
import DefaultLabels from '../public/labels/DefaultLabels.json';

import VueLazyload from 'vue-lazyload'
import ClickOutsideDirective from "@/core/ClickOutsideDirective";




const {VUE_APP_VERSION} = process.env;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const SmartSearchConfig = ref<SmartSearchConfigInterface>(DefaultConfig)
const SmartSearchTranslations = ref<SmartSearchTranslationsInterface>(DefaultLabels)
searchLogger.log(`Version: ${VUE_APP_VERSION}`)
const pinia = createPinia();


async function initializeAutocomplete() {
  searchLogger.log('initialising autocomplete')
  const autocompleteApp = createApp(AutocompletePopup);
  autocompleteApp.directive('click-outside', ClickOutsideDirective);
  autocompleteApp.provide('SmartSearchConfig', SmartSearchConfig);
  autocompleteApp.provide('SmartSearchTranslations', SmartSearchTranslations);
  autocompleteApp.use(pinia)
  autocompleteApp.use(VueLazyload)
  autocompleteApp.mount('#smartsearch-autocomplete');
}

async function initializeSerpPage() {
  
  searchLogger.log('initialising Serp')
   const serpApp = createApp(SerpPage);
  serpApp.directive('click-outside', ClickOutsideDirective);
  serpApp.provide('SmartSearchConfig', SmartSearchConfig);
  serpApp.provide('SmartSearchTranslations', SmartSearchTranslations);
  serpApp.use(pinia)
  serpApp.use(VueLazyload)
  serpApp.mount('#smartsearch-serp');
}


(async () => {
  if (!searchIsConfigured()) {
    searchErrorLogger.log('SmartSearch needs config in window.SmartSearchConfig')
    return
  }
  
  const frontSettings = await fetchFrontSettings()
  const {settings, labels} = frontSettings
  
  
  // const mergedConfig = deepAssign()(DefaultConfig, settings)
  const mergedLabels = deepAssign()(DefaultLabels, labels)
  
  SmartSearchTranslations.value = mergedLabels as SmartSearchTranslationsInterface
  
  
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  SmartSearchConfig.value = settings as SmartSearchConfigInterface
  restoreDefaultSettings()
  
  searchLogger.log('SmartSearchTranslations: ', SmartSearchTranslations.value)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  searchLogger.log('SmartSearchConfig: ', SmartSearchConfig.value)
  await initializeAutocomplete();
  await initializeSerpPage();
})();


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.SmartSearchInstanceConfig = SmartSearchConfig.value
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window._QONizer = window._QONizer || {}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window._QONizer.initializeAutocomplete = initializeAutocomplete
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window._QONizer.initializeSerpPage = initializeSerpPage

export {SmartSearchConfig}
